import { UseQueryResult, useQuery } from "react-query";
import { PericiaMetricV2DTO } from "../../../../entities/pericia/model/dto";
import {
  GetPericiasMetricsByCostumerRequest,
  getPericiasMetricsByCostumerRequest
} from "../../../../entities/pericia/api/get-pericias-metrics-by-costumer";
import { Costumer } from "../../../../entities/costumer";
import { isCalendarDateRangeValid, toInclusiveTimestampRange } from "../../../../shared/lib/date-range";

export interface UseGetPericiasMetricsProps {
  costumer: Costumer;
  startDate: Date;
  endDate: Date;
  enabled: boolean;
}

export const queryKeys = {
  getPericiasMetrics: (props: GetPericiasMetricsByCostumerRequest) => ["getPericiasMetrics", props]
};

export function useGetPericiasMetricsByCostumer(props: UseGetPericiasMetricsProps): UseQueryResult<PericiaMetricV2DTO[]> {
  const hasValidRange = isCalendarDateRangeValid({ start: props.startDate, end: props.endDate });
  const range = hasValidRange
    ? toInclusiveTimestampRange({ start: props.startDate, end: props.endDate })
    : { start: "", end: "" };
  const args = {
    id_costumer: props.costumer.id,
    start_date: range.start,
    end_date: range.end
  };

  return useQuery(queryKeys.getPericiasMetrics(args), () => getPericiasMetricsByCostumerRequest(args), {
    retry: false,
    refetchOnWindowFocus: false,
    enabled:
      props.enabled &&
      hasValidRange &&
      Boolean(props.costumer.id)
  });
}
